import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { UserToken } from '../../../../shared/src/types/User'

interface AuthState {
  user: UserToken | null
  isLoggedIn: boolean,
  sessionExpired: boolean,
}

const initialState: AuthState = {
  user: null,
  isLoggedIn: false,
  sessionExpired: false,
}

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {

    setUser: (state, action: PayloadAction<UserToken>) => {
      state.user = action.payload
      state.isLoggedIn = true
      state.sessionExpired = false
    },

    logout: (state) => {
      state.user = null
      state.isLoggedIn = false
    },

    setSessionExpired: (state, action: PayloadAction<boolean>) => {
      state.sessionExpired = action.payload
    }

  },
})

export const { setUser, logout, setSessionExpired } = authSlice.actions

export const selectCurrentUser = (state: { auth: AuthState }) => state.auth.user
export const selectIsLoggedIn = (state: { auth: AuthState }) => state.auth.isLoggedIn
export const selectSessionExpired = (state: { auth: AuthState }) => state.auth.sessionExpired

export default authSlice.reducer